export const endpoints = {
    product_search: (query) =>
        'index.php?route=module/isearch/ajaxget&k=' + query,
    latest: 'index.php?route=api/latest',
    homepage_carousel: 'index.php?route=api/homepage_carousel',
    vebinars_slider: 'index.php?route=api/slider_seminars',
}
